/* eslint-disable @typescript-eslint/no-unused-vars */
import styled, { css } from 'styled-components';
import { StyledTagProps, CpdsDropDownItemProps } from '../typings';
import { themeToken } from '../../utils/cpds-utils';

const colorMapper = (cpds) => {
  return {
    CLOSED: {
      color: cpds.drop_down_closed_color,
    },
    OPEN: {
      color: cpds.drop_down_open_color,
    },
    DISABLED_LIGHT: {
      color: cpds.drop_down_disabled_color,
    },
    APPLIED_LIGHT: {
      color: cpds.drop_down_applied_color,
      fontWeight: cpds.drop_down_applied_font_weight
    },


    // CLOSED_DARK: {
    //   color: cpds.drop_down_color,
    // },
    // OPEN_DARK: {
    //   color: cpds.drop_down_color,
    // },
    // DISABLED_DARK: {
    //   color: cpds.drop_down_color,
    // },
    // APPLIED_DARK: {
    //   color: cpds.drop_down_color,
    //   fontWeight:cpds.drop_down_applied_font_weight
    // },
  };
};

const CpdsDropDownStyleTag = styled.div`
${({ theme: { styles: { cpds } }, isOpen = false, ...props }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);

    return css`    
      position: relative;
      display: inline-block;
      ${isOpen
        ? css`
            .cpds-drop-down-items {
              display: block;
            }
            .drop-down-mobile-option-list {
              display: block;
            }
          `
        : ``}
      ${(props) => props.styleOverrides || ''}
  `}
  }
`;

const CpdsDropDownButton = styled.button<StyledTagProps>`
  ${({
  theme: {
    styles: { cpds }
  },
  isOpen = false,
  ...props
}) => {
    const { token, themeColorMode } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    const state = props?.state || 'CLOSED';
    return css`    
      background-color: unset;
      color: ${colorMapper(token)?.[`${state}`]?.color || token.drop_down_closed_color};
      border: none;
      border-radius:unset;
      cursor: pointer;
      width:100%;
      padding-bottom: 4px;

      ${isOpen
        ? css`
              svg {
                transform: rotate(180deg);
              }
            `
        : ``
      }

      ${state === 'APPLIED'
        ? `
        border-bottom: 2px solid ${token.drop_down_applied_border_color};
        `
        : ``}

      // &::after {
      //   content: "";
      //   position: absolute;
      //   right: 10px;
      //   top: 50%;
      //   width: 14px;
      //   height: 14px;
      //   background: url('https://mesocp3.azureedge.net/media/zpeppi1l/dropdown.svg') no-repeat center center;
      //   background-size: contain;
      //   transform: rotate(0deg) translateY(-50%);
      //   transition: transform 0.3s ease-in-out;
      //   ${themeColorMode === 'DARK' ? `filter: invert(1);` : ``}
      // }
    ${(props) => props.styleOverrides || ''}
  `}}
`;

const CpdsDropDownItems = styled.div`
${({ theme: { styles: { cpds } }, ...props }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    const containerheight = props.maxItemsToShow || 0;
    return css` 
    ${containerheight > 0 ? `height:calc(${containerheight} * ${token.drop_down_item_height});` : ``}
    display: none;
    position: absolute;
    padding:${token.drop_down_wrapper_padding};
    background-color: ${token.drop_down_item_background_color};
    width: max-content;
    min-width: 242px;
    box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
    z-index: 1;    
    background-color: #ffffff;
    ${(props) => props.styleOverrides || ''}
  `}
  }
`;

const CpdsDropDownItem = styled.div`
${({ theme: { styles: { cpds } }, selected = false, ...props }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    return css` 
    display: flex;
    flex-direction: row;
    height:${token.drop_down_item_height};
    color: ${token.drop_down_item_color};
    background-color: ${selected ? token.drop_down_option_item_selected_color : 'transparent'}; 

    &:hover {
      background-color: ${token.drop_down_option_item_selected_color}; 
    }
    ${(props) => props.styleOverrides || ''}
  `}
  }
`;

const CpdsDropDownItemLeading = styled.div`
  ${({
  theme: {
    styles: { cpds }
  },
  ...props
}) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    return css`
    display: flex;
    justify-content: center;
    align-items: center;    
    width:${token.drop_down_item_img_width};
    ${(props) => props.styleOverrides || ''}
  `}}
`;

const CpdsDropDownItemTrailing = styled.div`
  ${({
  theme: {
    styles: { cpds }
  },
  ...props
}) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    return css`
    display: flex;
    justify-content: center;
    align-items: center;    
    width:${token.drop_down_item_img_width};
    ${(props) => props.styleOverrides || ''}
  `}}
`;

const CpdsDropDownItemImg = styled.div<CpdsDropDownItemProps>`
  ${({
  theme: {
    styles: { cpds }
  },
  ItemLeading,
  ...props
}) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    return css`    
    width:100%;
    height:100%;
    background: url(${ItemLeading}) no-repeat;   
    ${(props) => props.styleOverrides || ''}
  `}}
`;

const CpdsDropDownItemLink = styled.a`
${({ theme: { styles: { cpds } }, ...props }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    return css`    
      text-decoration: none !important;
      flex:1;
      color:${token.drop_down_item_color};
      padding:${token.drop_down_item_padding};
      
      ${(props) => props.styleOverrides || ''}
  `}
  }
`;

const DropdownPopupOptionList = styled.div.attrs({
  'data-cy': 'drop-downmobileoptionlist',
  className: 'drop-down-mobile-option-list',
})`
  ${({
  theme: {
    styles: { cpds },
  },
  props,
}) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    return css`
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      bottom: 0;
      z-index: 9999;
      background-color: ${token?.drop_down_bg_color_mobile}; 
      display: none;
      box-shadow: 0px 2px 10px 0px #00000012;
    `;
  }}
`;

const DropdownPopupActionHeader = styled.div.attrs({
  'data-cy': 'dropdownpopupactionheader',
})`
  ${({
  theme: {
    styles: { cpds },
  },
  props,
}) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    return css`
      padding: 0 ${token?.spacing?.space_16} 0px;
      display: flex;
      justify-content: flex-end;
      align-items: flex-end;
      height: 60px;
    `;
  }}
`;

const DropdownPopupCloseButton = styled.button.attrs({
  'data-cy': 'dropdownpopupclosebutton',
})`
  ${({
  theme: {
    styles: { cpds },
  },
  props,
}) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    return css`
      background-color: unset;
      cursor: pointer;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      border: 1px solid ${token?.drop_down_close_btn_border_color_mobile}; 
      display: flex;
      align-items: center;
      justify-content: center;
      svg {
        width: 10px;
        height: 10px;
        path {
          fill: ${token?.drop_down_close_btn_icon_color_mobile}; 
        }
      }
    `;
  }}
`;

const DropdownPopupOptions = styled.div.attrs({
  'data-cy': 'dropdownpopupoptions',
  className: 'cpds-meta-roman-medium-book-09',
})`
  .cpds-drop-down-item {
    padding: 12px 16px;
    display: flex;
    align-items: center;
    max-height: 40px;
    gap: 8px;
    .cpds-drop-down-item-leading {
      width: 16px;
      height: 16px;
      svg {
        width: 12px;
        height: 9px;
      }
    }
    .cpds-drop-down-item-link {
      padding: 0;
    }
  }
`;

export {
  CpdsDropDownStyleTag,
  CpdsDropDownButton,
  CpdsDropDownItems,
  CpdsDropDownItem,
  CpdsDropDownItemLeading,
  CpdsDropDownItemTrailing,
  CpdsDropDownItemImg,
  CpdsDropDownItemLink,
  DropdownPopupOptionList,
  DropdownPopupActionHeader,
  DropdownPopupCloseButton,
  DropdownPopupOptions
};
